import { selectDetectTimezoneAbbr, selectDsTimezoneAbbreviation, selectEpisodes, selectLocaleLanguage, selectPublicConfig, selectTimezone, selectVodDurationMetrics } from "@adm-media/adam-store-plugin";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFormattedFirstAvailableDate } from "../utils/get-live-date";
import moment from "moment";
export var useEpisodesToShowInHomepage = function (_a) {
    var _b, _c;
    var contents = _a.contents, styles = _a.styles;
    var publicConfig = useSelector(selectPublicConfig);
    var episodes = useSelector(selectEpisodes);
    var timezoneAbbreviation = useSelector(selectDetectTimezoneAbbr);
    var dsTimezoneAbbreviation = useSelector(selectDsTimezoneAbbreviation);
    var locale = useSelector(selectLocaleLanguage);
    var timezone = useSelector(selectTimezone);
    var vodDurationMetrics = useSelector(selectVodDurationMetrics);
    var _d = useState([]), episodesToShowInHomepage = _d[0], setEpisodesToShowInHomepage = _d[1];
    useEffect(function () {
        var _a, _b;
        var episodesIdsToShow = typeof ((_a = publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.homepageAgendaEpisodesIds) === null || _a === void 0 ? void 0 : _a.length) === "number" && ((_b = publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.homepageAgendaEpisodesIds) === null || _b === void 0 ? void 0 : _b.length) > 0
            ? publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.homepageAgendaEpisodesIds
            : null;
        var episodesToShow = episodes.filter(function (episode) {
            if (episodesIdsToShow === null)
                return true;
            else
                return episodesIdsToShow.includes(episode.id);
        });
        setEpisodesToShowInHomepage(episodesToShow);
    }, [episodes, publicConfig]);
    var formattedLiveDate = getFormattedFirstAvailableDate({
        liveDatesInUtc: episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage.map(function (episode) { var _a; return (_a = episode === null || episode === void 0 ? void 0 : episode.live_scheduling) === null || _a === void 0 ? void 0 : _a.start_at; }),
        timezone: timezone,
        timeFormatType: contents.time_format,
        dateFormatType: contents.date_format,
        dsTimezoneAbbreviation: dsTimezoneAbbreviation,
        timezoneAbbreviation: timezoneAbbreviation,
        currentUTCTime: moment.utc().format(),
        hideTime: styles === null || styles === void 0 ? void 0 : styles.hero_hide_live_time,
        locale: locale
    });
    var formattedVODDate = getFormattedFirstAvailableDate({
        liveDatesInUtc: episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage.map(function (episode) { var _a; return (_a = episode === null || episode === void 0 ? void 0 : episode.vod_scheduling) === null || _a === void 0 ? void 0 : _a.start_at; }),
        timezone: timezone,
        timeFormatType: contents.time_format,
        dateFormatType: contents.date_format,
        dsTimezoneAbbreviation: dsTimezoneAbbreviation,
        timezoneAbbreviation: timezoneAbbreviation,
        currentUTCTime: moment.utc().format(),
        hideTime: styles === null || styles === void 0 ? void 0 : styles.hero_hide_vod_time,
        locale: locale
    });
    var vodDurationInHoursToDisplay = (episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage.length) === 1 && typeof ((_b = episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage[0]) === null || _b === void 0 ? void 0 : _b.max_channel_duration) === "number"
        ? (_c = episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage[0]) === null || _c === void 0 ? void 0 : _c.max_channel_duration
        : null;
    var vodDurationToDisplay = typeof vodDurationInHoursToDisplay === "number" && !Number.isNaN(vodDurationInHoursToDisplay)
        ? !!vodDurationMetrics
            ? vodDurationInHoursToDisplay / 24
            : vodDurationInHoursToDisplay
        : null;
    var showEpisodesCards = styles.hero_show_multiple_episodes;
    var hideNextEpisodeSchedule = styles.hero_hide_next_episode_schedule;
    var showScrollDownButtonDesktop = styles.hero_height_desktop === "100vh";
    var showScrollDownButtonMobile = styles.hero_height_mobile === "100vh";
    return {
        episodesToShowInHomepage: episodesToShowInHomepage,
        formattedLiveDate: formattedLiveDate,
        formattedVODDate: formattedVODDate,
        vodDurationInHoursToDisplay: vodDurationInHoursToDisplay,
        vodDurationToDisplay: vodDurationToDisplay,
        showEpisodesCards: showEpisodesCards,
        hideNextEpisodeSchedule: hideNextEpisodeSchedule,
        showScrollDownButtonDesktop: showScrollDownButtonDesktop,
        showScrollDownButtonMobile: showScrollDownButtonMobile
    };
};
